import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import useWebContext from '../../hooks/useWebContext';
import { MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { MyMModal } from '../../ui-elements/MyMModal';
import { FileMappingIcon } from '../../ui-parts/FileMappingIcon';
import { Pager } from '../../ui-parts/Pager';
import TooltipLabel from '../../ui-parts/TooltipLabel';
import { utility } from '../../utility';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { MyMTooltip } from '../../ui-elements/MyMToolTip'
import { IconButton } from '@mui/material';
import PendingIcon from '@mui/icons-material/Pending';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/**
 * UserProfile Favorite File Component
 */
const UserProfileFavoriteFile = React.memo(({ screenId, apiRequest, controlSettings, messageList, favoriteBoxFileInfo, setIsLoading, favoritePageNum, setFavoritePageNum, getFavoriteFilePage }) => {
  // 変数・State
  const { screenSettings } = useWebContext(screenId);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const isMobile = useMediaQuery('(max-width:600px)');
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const tooltipRefs = useRef({});
  const isPc = useMediaQuery(mediaQuery.pc);

  // お気に入りファイルのプレビューを表示
  const onClickFavoriteFileLink = (e, fileId) => {
    setPreviewFileId(fileId);
    setIsModalOpen(true);
  }

  // お気に入りファイル一覧コンポーネント
  const UserProfileMyFavoriteDocumentList = () => {
    // Removeボタン押下時イベント
    const onClickRemoveFavoriteFile = (key) => {
      const param = {
        Key: key,
        UnFavorite: true,
      };

      const callbackSuccess = () => {
        // Favorite Fileページ情報再取得
        getFavoriteFilePage(favoritePageNum);
      }

      const callbackFailed = () => setIsLoading(false);

      setIsLoading(true);
      apiRequest.requestJson('api/box-file/favorite', 'POST', callbackSuccess, callbackFailed, param);
    };

    // お気に入りファイル0件の場合の表示
    const FavoriteFileNoContentBox = ({ content }) => {
      return (
        <Box sx={{ padding: "10px" }}>
          <Typography fontSize="15px" >{content}</Typography>
        </Box>
      )
    }

    const handleTooltipToggle = (fileId) => {
      if (openTooltipId === fileId) {
        setOpenTooltipId(null);
      } else {
        setOpenTooltipId(fileId);
      }
    };

    const handleClickOutside = useCallback((event) => {
      if (openTooltipId && tooltipRefs.current[openTooltipId] && !tooltipRefs.current[openTooltipId].contains(event.target)) {
        setOpenTooltipId(null);
      }
    }, [openTooltipId]);

    useEffect(() => {
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, [handleClickOutside]);

    return (
      <Grid container spacing={1}>
        <Grid item xs={12} className="pt-3"  >
          {
            favoriteBoxFileInfo !== undefined && favoriteBoxFileInfo.ItemList.length > 0 ?
              <>
                <List disablePadding sx={{ maxHeight: "410px", height: "410px",}} >
                  {favoriteBoxFileInfo.ItemList.map((item) => {
                    const ellipsisFileName = utility.convertEllipsisFormat(item.NameDisp, isMobile ? screenSettings.FavoriteBoxFileNameMaxLength_Mobile : screenSettings.FavoriteBoxFileNameMaxLength);

                    return (
                      <ListItem key={item.FileId} sx={{ padding: "5px 8px", minHeight: "55px" }}>
                        <FileMappingIcon screenId={screenId} extension={item.Extension} width="25px" height="25px" />
                        {
                          isPc ?
                            <>
                              <MyMLink
                                underline="hover"
                                sx={{ color: "#fff", marginLeft: "15px" }}
                                onClick={(e) => { onClickFavoriteFileLink(e, item.FileId) }}
                              >
                                <TooltipLabel className='text-wrap' sx={{ textAlign: 'left' }} toolTipValue={item.NameDisp !== ellipsisFileName ? item.NameDisp : ''} value={ellipsisFileName} />
                              </MyMLink>
                            </>
                            :
                            <>
                              <Grid item xs={5}>
                                <MyMLink
                                  underline="hover"
                                  sx={{ color: "#fff", marginLeft: "15px" }}
                                  onClick={(e) => { onClickFavoriteFileLink(e, item.FileId) }}
                                >
                                  <TooltipLabel className='text-wrap' sx={{ textAlign: 'left' }} toolTipValue={item.NameDisp !== ellipsisFileName ? item.NameDisp : ''} value={ellipsisFileName} />
                                </MyMLink>
                              </Grid>
                            </>
                        }
                        {!isPc && item.NameDisp !== ellipsisFileName &&
                          <div ref={(el) => tooltipRefs.current[item.FileId] = el}>
                            <MyMTooltip
                              title={item.NameDisp}
                              arrow
                              open={openTooltipId === item.FileId}
                              onClose={() => setOpenTooltipId(null)}
                              onOpen={() => handleTooltipToggle(item.FileId)}
                            >
                              <IconButton
                                sx={{ marginLeft: "10px" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleTooltipToggle(item.FileId);
                                }}
                              >
                                <PendingIcon sx={{ color: "#fff" }} />
                              </IconButton>
                            </MyMTooltip>
                          </div>
                        }
                        <MyMLink
                          underline="hover"
                          sx={{ color: "#fff", marginLeft: "auto" }}
                          onClick={() => { onClickRemoveFavoriteFile(item.FileId) }}
                        >
                          {controlSettings.LabelList.lnkRemove}
                        </MyMLink>
                      </ListItem>
                    )
                  })
                  }
                </List>
                <Box sx={{ pt: 1 }}>
                  <Pager
                    resultListItem={favoriteBoxFileInfo}
                    handleChangePage={(pageNum) => setFavoritePageNum(pageNum)}
                    labelList={controlSettings.LabelList}
                    pageNumber={favoritePageNum}>
                  </Pager>
                </Box>
              </>
              :
              <FavoriteFileNoContentBox content={messageList.MyM_MSG_I_0008} />
          }
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      <Grid item xs={12} md={12} lg={6} >
        <Box className='profile-content'>
          <TableContainer>
            <Table sx={{ border: 0, '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableHead>
                <TableRow>
                  <TableCell variant='head' sx={{ padding: '16px 0' }}>
                    <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblMyFavorites}</MyMVariantLabel>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className='profile-content-body'>
                <TableRow>
                  <TableCell variant='head' sx={{ padding: "0 16px", verticalAlign: 'baseline' }}>
                    <UserProfileMyFavoriteDocumentList />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
    </>
  );
})
export default UserProfileFavoriteFile;
